import { HttpErrorResponse } from '@angular/common/http';
import { ApiNamesEnum } from '../enums';
import { CerberusErrorCodesEnum, NephilimErrorCodesEnum, HuginnErrorCodesEnum, WolandErrorCodesEnum } from '../enums/error-codes';

export class ErrorHelper {
    public static getErrorCode(data: HttpErrorResponse, apiName: ApiNamesEnum):
        CerberusErrorCodesEnum | NephilimErrorCodesEnum | HuginnErrorCodesEnum | WolandErrorCodesEnum {

        if (!data || !data.error) {
            return CerberusErrorCodesEnum.Unknown;
        }

        const error = data.error;
        const authError = error.authError || {};
        let errorCode = (error.errorCode || authError.errorCode);


        switch (apiName) {
            case ApiNamesEnum.Cerberus: return errorCode as CerberusErrorCodesEnum;
            case ApiNamesEnum.Nephilim: return errorCode as NephilimErrorCodesEnum;
            case ApiNamesEnum.Huginn: return errorCode as HuginnErrorCodesEnum;
            case ApiNamesEnum.Woland: return errorCode as WolandErrorCodesEnum;
            default: return errorCode;
        }
    }
}
